(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-404"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wt-404-gear')) {
    /**
     * 404 easter egg: every click on the wooden gear makes it spin faster and updates a little
     * counter ("3 spins. Still no page."). The speed eases back down after a moment.
     * With prefers-reduced-motion the gear does not animate; each click turns it by one tooth instead.
     */
    class Wt404Gear extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-gear]');
        this.svg = this.querySelector('[data-gear-svg]');
        this.output = this.querySelector('[data-gear-count]');
        if (!this.button || !this.svg) return;

        this.count = 0;
        this.rate = 1;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        clearTimeout(this.idleTimer);
        clearInterval(this.decayTimer);
      }

      onClick = () => {
        this.count += 1;
        this.updateMessage();

        if (this.reducedMotion.matches) {
          this.svg.style.rotate = `${this.count * 30}deg`;
          return;
        }

        this.rate = Math.min(this.rate + 2.5, 24);
        this.svg.style.animationPlayState = 'running';
        this.applyRate();

        clearTimeout(this.idleTimer);
        clearInterval(this.decayTimer);
        this.idleTimer = setTimeout(() => {
          this.decayTimer = setInterval(() => {
            this.rate = Math.max(1, this.rate * 0.88);
            if (this.rate < 1.05) this.rate = 1;
            this.applyRate();
            if (this.rate === 1) {
              clearInterval(this.decayTimer);
              this.svg.style.animationPlayState = 'paused';
            }
          }, 120);
        }, 1400);
      };

      applyRate() {
        const animation = this.svg.getAnimations ? this.svg.getAnimations()[0] : null;
        if (!animation) return;
        if (typeof animation.updatePlaybackRate === 'function') {
          animation.updatePlaybackRate(this.rate);
        } else {
          animation.playbackRate = this.rate;
        }
      }

      updateMessage() {
        if (!this.output) return;
        const maxAt = parseInt(this.dataset.maxAt, 10) || 10;
        let message = this.dataset.many;
        if (this.count === 1) message = this.dataset.one;
        if (this.count >= maxAt && this.dataset.max) message = this.dataset.max;
        if (!message) return;
        this.output.textContent = message.replace(/\[count\]/g, String(this.count));
      }
    }

    customElements.define('wt-404-gear', Wt404Gear);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wt-article"]) return;
  try {
    
  if (!customElements.get('wt-article-toc')) {
    // Accents left over after NFKD normalization (U+0300 to U+036F), so ids stay plain ASCII.
    const COMBINING_MARKS = new RegExp(`[${String.fromCharCode(0x300)}-${String.fromCharCode(0x36f)}]`, 'g');

    /**
     * "In this article" list. Collects the article's h2 (and h3) headings, gives each one an id
     * when it has none, scrolls smoothly to a heading on click (instant with reduced motion) and
     * marks the heading currently being read. Stays hidden when there are too few headings.
     */
    class WtArticleToc extends HTMLElement {
      connectedCallback() {
        const source = document.getElementById(this.dataset.source ?? '');
        this.list = this.querySelector('[data-toc-list]');
        if (!source || !this.list) return;

        const selector = this.dataset.levels === 'h2' ? 'h2' : 'h2, h3';
        this.headings = [...source.querySelectorAll(selector)].filter(
          (heading) => heading.textContent?.trim() && !heading.closest('aside')
        );
        if (this.headings.length < Number(this.dataset.min || 2)) return;

        this.list.replaceChildren(...this.headings.map((heading) => this.#createItem(heading)));
        this.links = [...this.list.querySelectorAll('a')];
        this.list.addEventListener('click', this.#onClick);
        this.hidden = false;
        this.#observe();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.list?.removeEventListener('click', this.#onClick);
      }

      /** @param {HTMLElement} heading */
      #createItem(heading) {
        const item = document.createElement('li');
        item.className = heading.tagName === 'H3' ? 'wt-toc__item wt-toc__item--sub' : 'wt-toc__item';

        const link = document.createElement('a');
        link.className = 'wt-toc__link';
        link.href = `#${this.#ensureId(heading)}`;
        link.textContent = heading.textContent.trim();

        item.append(link);
        return item;
      }

      /** @param {HTMLElement} heading */
      #ensureId(heading) {
        if (heading.id) return heading.id;

        const base =
          heading.textContent
            .trim()
            .toLowerCase()
            .normalize('NFKD')
            .replace(COMBINING_MARKS, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .slice(0, 60) || 'section';

        let id = base;
        let suffix = 2;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        return id;
      }

      /** @param {MouseEvent} event */
      #onClick = (event) => {
        const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
        if (!(link instanceof HTMLAnchorElement)) return;

        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;

        event.preventDefault();
        // Close the mobile list first so the scroll target does not move afterwards.
        this.querySelector('details[open]')?.removeAttribute('open');

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(history.state, '', link.hash);

        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      };

      #observe() {
        if (!('IntersectionObserver' in window)) return;

        this.activeIndex = -1;
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              const index = this.headings.indexOf(/** @type {HTMLElement} */ (entry.target));
              if (entry.isIntersecting) {
                this.#setActive(index);
              } else if (
                index === this.activeIndex &&
                entry.rootBounds &&
                entry.boundingClientRect.top > entry.rootBounds.bottom
              ) {
                // Scrolled back up past the active heading: the previous one is being read.
                this.#setActive(index - 1);
              }
            }
          },
          { rootMargin: '0px 0px -65% 0px' }
        );
        this.headings.forEach((heading) => this.observer.observe(heading));
      }

      /** @param {number} index */
      #setActive(index) {
        this.activeIndex = index;
        this.links.forEach((link, i) => {
          if (i === index) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('wt-article-toc', WtArticleToc);
  }

  } catch(e) { console.error(e); }
})();
})();
